/**
 * The address label of a new node, derived from its name the same way the
 * backend does (services/node_signups.suggest_slug): "Acme & Co." → "acme-co".
 * The backend has the last word (reserved labels, what is taken); this only
 * keeps the field in step with the name while the person types.
 */

const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function suggestSlug(name) {
    let slug = String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    slug = slug.replace(/-{2,}/g, '-').slice(0, 64).replace(/-+$/, '');
    return slug || 'node';
}

export function isValidSlug(slug) {
    return SLUG_RE.test(String(slug || ''));
}
